import script from "./SanitisedHtml.vue?vue&type=script&lang=ts&setup=true"
export * from "./SanitisedHtml.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__